/*global google*/
/*eslint no-undef: "error"*/

import React, {Component} from 'react';
import ReactDOM from 'react-dom'

import LocatorResult from './LocatorResult';
import Tracker from '../common/Tracker';

const DEFAULT_MAP_CONFIG = {
    center: {lat: 39.135216, lng: -96.060805},
    zoom: 4
};

const CATEGORY = "locator";

class GoogleMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            map: null,
            markers: null,
            openWindow: null
        }
    }

    componentDidMount() {
        // console.log("will mount");
        if (!window.initMap) {
            window.initMap = this.initMap;
            const script = document.createElement("script");
            script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw&callback=initMap";
            script.async = true;
            document.body.appendChild(script);
        } else {
            // console.log("skipping script init");
            this.initMap();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.map && nextProps.results) {
            if (!this.props.mobile) {
                // console.log('handle map updates');
                this.handleDesktopMapUpdates(nextProps);
            } else {
                this.handleMobileMapUpdates(nextProps);
            }
        }
    }

    handleDesktopMapUpdates(nextProps) {
        // console.log('lasdflkajsdfljasdf');
        if (this.state.markers) {
            this.setState((state, props) => {
                var markers = {};

                // console.log("markers: %o", state.markers);

                //add new markers
                nextProps.results.forEach((result, index) => {
                    if (!state.markers[result.key]) {
                        // console.log("adding: " + result.key);
                        markers[result.key] = this.markerForResult(result, index, nextProps.focusedIndex);
                    } else {
                        // console.log("updating: " + result.key);
                        state.markers[result.key].setIcon(this.getMarkerIcon(index, nextProps.focusedIndex, result));
                        markers[result.key] = state.markers[result.key];
                    }
                });

                Object.keys(state.markers).forEach((key) => {
                    if (!markers[key]) {
                        // console.log("removing: " + key);
                        state.markers[key].setMap(null);
                        // console.log("post-remove");
                    }
                });

                return {markers: markers, focusedIndex: nextProps.focusedIndex};
            });
            this.fitBounds(nextProps.results);
        } else if (nextProps.results && nextProps.results.length) {
            let markers = {};
            nextProps.results.forEach((result, index) => {
                // console.log("adding: " + result.key);
                markers[result.key] = this.markerForResult(result, index, nextProps.focusedIndex);
            });

            this.fitBounds(nextProps.results);
            this.setState({markers: markers, focusedIndex: nextProps.focusedIndex});
        }
    }

    handleMobileMapUpdates(nextProps) {
        if (this.state.markers) {
            let result = nextProps.results[nextProps.focusedIndex || 0];
            if (result != null) {
                let position = new google.maps.LatLng({lat: result.latitude, lng: result.longitude})
                this.state.markers[0].setPosition(position);
                this.state.map.setCenter(position, true);
            }
        } else if (nextProps.results.length) {
            let result = nextProps.results[nextProps.focusedIndex || 0];
            let position =  new google.maps.LatLng({lat: result.latitude, lng: result.longitude});
            let marker = new google.maps.Marker({
                position: position,
                map: this.state.map,
                icon: {
                    url: (result.isPreferred ? '/img/imgMapPinPreferred.svg' : '/img/img-map-pin.svg'),
                }
            });
            this.setState({
                markers: [marker]
            });
            this.state.map.setZoom(14);
            this.state.map.setCenter(position);
            google.maps.event.trigger(this.state.map, "resize");
        }
    }

    initMap = () => {
        let config = {...DEFAULT_MAP_CONFIG};
        if (this.props.mobile) {
            let mobileConfig = {
                fullscreenControl: false,
                streetViewControl: false,
                zoomControl: false,
                mapTypeControl: false
            }
            config = {...config, ...mobileConfig};
            // console.log("map config: %o", config);
        }
        let map = new google.maps.Map(document.getElementById('map'), config);
        map.addListener('click', () => {
            Tracker.trackEvent(CATEGORY, "map click", "", "");
            if (this.state.openWindow) {
                this.state.openWindow.close();
            }
            this.setState({openWindow: null});
        });

        this.setState({map: map});

        if (this.state.results) {
            // console.log('uhhh what??');
            this.plotResults();
        }
    }

    getMarkerIcon(index, focusedIndex, result) {
        let url = '/img/img-map-pin.svg';
        if (focusedIndex != null && focusedIndex === index) {
            // console.log("selected");
            if (result.isPreferred) {
                url = '/img/imgMapPinHighlightedPreferred.svg';
            } else {
                url = '/img/img-map-pin-highlighted.svg';
            }
        } else if (result.isPreferred) {
            url = '/img/imgMapPinPreferred.svg';
        }
        return url;
    }

    plotResults() {
        // console.log("plotResults");
        if (this.state.map && this.props.results) {
            // console.log("plotting results");
            this.props.results.forEach((result, index) => {
                new google.maps.Marker({
                    position: new google.maps.LatLng({lat: result.latitude, lng: result.longitude}),
                    map: this.state.map,
                    icon: {
                        url: this.getMarkerIcon(result),
                    }
                });
            });
        }
    }

    getResult(result) {
        return (
            <LocatorResult result={result} imageSize={this.props.imageSize} onClick={this.props.onLocationSelect.bind(null, result)} />
        );
    }

    markerForResult(result, index, focusedIndex) {
        var infowindow = new google.maps.InfoWindow({});

        var div = document.createElement('div');
        ReactDOM.render( this.getResult(result), div );
        infowindow.setContent( div );

        let marker = new google.maps.Marker({
            position: new google.maps.LatLng({lat: result.latitude, lng: result.longitude}),
            map: this.state.map,
            icon: {
                url: this.getMarkerIcon(index, focusedIndex, result),
            }
        });
        marker.addListener('click', () => {
            Tracker.trackEvent(CATEGORY, "marker click", result.name, "");
            if (this.state.openWindow) {
                this.state.openWindow.close();
            }
            infowindow.open(this.state.map, marker);
            this.setState({openWindow: infowindow});
        });

        return marker;
    }

    fitBounds(results) {
        if (this.state.map && results && results.length) {
            // console.log("fitting bounds for results: %o", results);
            let bounds = new google.maps.LatLngBounds();

            results.forEach((result, index) => {
                let latLng = new google.maps.LatLng({lat: result.latitude, lng: result.longitude});
                bounds.extend(latLng);
            });

            this.state.map.fitBounds(bounds);
        } else {
            this.state.map.setCenter(new google.maps.LatLng({lat: DEFAULT_MAP_CONFIG.center.lat, lng: DEFAULT_MAP_CONFIG.center.lng}));
            this.state.map.setZoom(DEFAULT_MAP_CONFIG.zoom);
        }
    }

    render() {
        return (
            <div id="map" style={{position: "absolute", top: 0, right: 0, left: 0, bottom: 0}}>
            </div>
        );
    }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/locator/GoogleMap.js